import { useAnalyticsLayer } from '../pages/Map/DeckGl/Layers/useAnalyticsLayer';
import { useLayerTileAnalytics } from '../pages/Map/DeckGl/Layers/useLayerTileAnalytics';
import { Bbox } from 'ais-facade-api/api';
import { Dispatch, SetStateAction } from 'react';

export const useGetAnalyticsLayer = (
  viewState: Record<string, number>,
  isAnalyticsMode: boolean,
  bbox: Bbox,
  setShowLoader: Dispatch<SetStateAction<boolean>>,
  setDisabledMode: Dispatch<SetStateAction<boolean>>,
  analyticsMode: string,
) => {
  const analyticsLayer = useAnalyticsLayer(viewState, isAnalyticsMode, bbox, setShowLoader, setDisabledMode, analyticsMode);
  const layerTileAnalytics = useLayerTileAnalytics(isAnalyticsMode, analyticsMode);

  if (analyticsMode === 'dynamic') {
    return analyticsLayer;
  } else {
    return layerTileAnalytics;
  }
};
